<template>
  <div class="main-wrapper">
    <div class="patient-lending-program-section">
      <div class="content-wrapper">
        <PatientLendingPrograms class="lending-item" />
        <div class="circle-wrapper">
          <img class="patient-lending_image-circle-blue" src="@Shared/assets/images/SmallBlueOval.svg"
            alt="Small blue circle" />
          <img class="patient-lending_image-circle-orange" src="@Shared/assets/images/SmallOrangeOval.svg"
            alt="Small orange circle" />
          <div class="outer-circle">
            <div class="inner-circle" />
          </div>
        </div>
      </div>
      <div class="image-wrapper images-item">
        <div class="image-bubbles">
          <img class="manage-your-account_image_accent-circle-yellow"
            src="@Shared/assets/images/small-yellow-circle.svg" alt="Small yellow circle" />
          <img class="patient-lending-program_image" src="@Shared/assets/images/national-cancer-institute.png"
            alt="Doctor and a patient" />
          <img class="manage-your-account_image_accent-circle-green" src="@Shared/assets/images/GreenOval.svg"
            alt="Small green circle" />
        </div>
      </div>
    </div>

    <div>
      <VerticalDivider class="divider" style="height: 4px" />
    </div>
    <HowHSFandCMCWork />
    <Readytogetstarted />

    <div class="footnote">
      *APR not available with all healthcare providers
    </div>
  </div>
</template>

<script>
import VerticalDivider from "@Shared/components/VerticalDivider.vue";
import HowHSFandCMCWork from "./HowHSFandCMCWork.vue";
import PatientLendingPrograms from "./PatientLendingPrograms.vue";
import Readytogetstarted from "./Readytogetstarted.vue";

export default {
  name: "PatientLendingProgramsSection",
  components: {
    PatientLendingPrograms,
    Readytogetstarted,
    VerticalDivider,
    HowHSFandCMCWork,
  },
};
</script>

<style lang="scss" scoped>
.patient-lending-program-section {
  display: grid;
  grid-template-columns: 80% 20%;

  @media all and (max-width: $grid-breakpoint-lg) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    row-gap: 10%;
    margin-bottom: 95px;

    .lending-item {
      grid-row: 2;
    }

    .images-item {
      grid-row: 1;
    }
  }

  .content-wrapper {
    position: relative;
    margin-right: 15px;
    padding-left: 5px;
    padding-right: 5px;

    @media all and (max-width: $grid-breakpoint-lg) {
      margin: 0;
    }
  }

  .pe_container {
    overflow: hidden;
  }

  .manage-account-wrapper {
    display: flex;
    justify-content: center;
    flex-flow: row;
  }

  .circle-wrapper {
    position: absolute;
    right: 90%;
    top: 50%;
    transform: translateY(-50%);

    .patient-lending_image-circle-blue {
      position: absolute;
      z-index: 3;
      top: 75%;
      left: 75%;
    }

    .patient-lending_image-circle-orange {
      position: absolute;
      z-index: 2;
      top: 85%;
      left: 70%;
    }

    .outer-circle {
      width: 279px;
      height: 279px;
      border-radius: 50%;
      background: linear-gradient(180deg, #0b5637 0%, #4fa800 100%);
      position: relative;
      z-index: 1;
    }

    .inner-circle {
      background: #ffffff;
      border-radius: 50%;
      width: 206px;
      height: 206px;
      position: relative;
      z-index: 1;
      top: 13%;
      left: 13%;
    }

    @media all and (max-width: $grid-breakpoint-lg) {
      display: none;
    }
  }

  .patientlending-image-wrapper {
    display: flex;

    @media all and (max-width: $grid-breakpoint-lg) {
      justify-content: center;
    }

    .patientlending-image-bubbles {
      position: relative;
      padding-bottom: 10%;

      @media all and (max-width: $grid-breakpoint-lg) {
        padding-bottom: 0;
      }

      .patient-lending-program_image_accent-circle-blue {
        position: absolute;
        top: 55%;
        right: 70%;
        z-index: 1;
        width: 132px;
        height: 132px;
        opacity: 0.8;
      }

      .patient-lending-program_image_accent-circle-green {
        position: absolute;
        top: 50%;
        right: 85%;
        z-index: 2;
        width: 72px;
        height: 72px;
      }

      .patient-lending-program_image {
        position: relative;
        height: 341px;
        width: 403px;

        @media all and (max-width: $grid-breakpoint-md) {
          height: 330px;
          width: 330px;
        }
      }
    }
  }
}

.divider {
  margin-left: 22vh;
  margin-right: 22vh;

  @media all and (max-width: $grid-breakpoint-lg) {
    margin: 5%;
  }

  @media all and (max-width: $grid-breakpoint-md) {
    margin: 5%;
  }

  @media all and (max-width: $grid-breakpoint-sm) {
    margin: 0%;
  }
}

.main-wrapper {
  margin-right: 10vh;

  @media all and (max-width: $grid-breakpoint-lg) {
    margin: 5%;
  }
}

.footnote {
  margin-left: 5vh;
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0px 10vh 30px;

  @media all and (max-width: $grid-breakpoint-lg) {
    margin: 30px 0px;
  }

  @media all and (max-width: $grid-breakpoint-md) {
    margin: 0px;
  }
}

.image-wrapper {
  display: flex;

  @media all and (max-width: $grid-breakpoint-lg) {
    justify-content: center;
  }

  .image-bubbles {
    position: relative;
    max-height: 403px;
    max-width: 403px;

    @media all and (max-width: $grid-breakpoint-md) {
      max-height: 370px;
      max-width: 370px;
    }

    .manage-your-account_image_accent-circle-yellow {
      position: absolute;
      top: 0px;
      left: 75%;
      z-index: 1;
      width: 132px;
      height: 132px;
      opacity: 0.5;

      @media all and (max-width: $grid-breakpoint-lg) {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: 10%;
        margin: 0;
      }

      @media all and (max-width: $grid-breakpoint-md) {
        height: 102px;
        width: 102px;
      }
    }

    .manage-your-account_image_accent-circle-green {
      position: absolute;
      top: 80%;
      right: 75%;
      z-index: -1;
      width: 72px;
      height: 72px;

      @media all and (max-width: $grid-breakpoint-md) {
        height: 61px;
        width: 61px;
      }
    }

    .manage-your-account_image {
      position: relative;
      height: 403px;
      width: 403px;

      @media all and (max-width: $grid-breakpoint-md) {
        height: 330px;
        width: 330px;
      }
    }
  }
}
</style>
